import { Component, Input } from '@angular/core';

@Component({
  selector: 'lib-popover',
  templateUrl: './popover.component.html',
  styleUrls: ['./popover.component.scss']
})
export class PopoverComponent {

  @Input() icon!: string;
  @Input() message!: string;

}
